import React from "react";
import moment from "moment";
import Countdown from "react-countdown";
import {Spinner} from "react-bootstrap";
import {Navigate} from "react-router-dom";
import { useTranslation } from "react-i18next";

import LinkSentIcon from "assets/images/svg/link_sent_art.svg";
import {useResendEmailToken} from "pages/informations/info.service";

const LinkSentPage = () => {
  const { t } = useTranslation();
  const { preregisterData, handleResendEmailCode,isStillBlocked,isStillValid,routeState ,isLoading} = useResendEmailToken();

  if(!preregisterData) return <Navigate to='/register' />;
  if (isStillBlocked && !isStillValid) return <Navigate to="/info/blocked-email" state={routeState} />;

  return (
    <div className="registration link-send">
      <div className="row">
        <div className="col-lg-8 col-md-12 mx-auto">
          <div className="row">
            <div className="col-lg-6 col-md-4">
              <img className="background" src={LinkSentIcon} alt="background" />
            </div>
            <div className="col-lg-6 col-md-8">
              <div className="box-linksend">
                <h1>{t("links:sentTitle")}</h1>
                <p>{t("links:sentContent")}</p>
                {/*@ts-ignore*/}
                <Countdown key={moment(preregisterData.expiryDate).toISOString()}
                  date={preregisterData?.expiryDate ?? Date.now()}
                  renderer={(p) => (
                    <button className="btn-blue" disabled={isLoading || !p.completed} onClick={handleResendEmailCode}>
                        {isLoading ? <Spinner animation="border" size="sm" /> : null}
                        {p.completed ? "Send Again" : `${p.formatted.hours}:${p.formatted.minutes}:${p.formatted.seconds}`}
                    </button>
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LinkSentPage;
